import React from 'react';

import DataPointsBlock from '../DataPointsBlock';
import FeedbackBlock from '../FeedbackBlock';
import Item from '../TaskDrawer/Item';
import EstimatedSavingBlock from '../EstimatedSavingBlock';
import { Flex } from '@chakra-ui/react';
import { FEEDBACK_STATE } from '../FeedbackBlock/FeedbackBlock';
import CommentBlock from '../CommentBlock';
import DescriptionBlock from '../DescriptionBlock';

/**
 * Render content for error tasks
 *
 * Parent
 *      TaskDrawer
 */
function ErrorTaskContent({
  task,
  handleFeedbackSubmit,
  handleAssignUserChange,
}) {
  return (
    <>
      <div className="nexus-task-header">{task?.task_title}</div>
      <Item
        task={{
          status: task.status,
          priority: task.priority,
          dueDate: task.due_on || 'No due date',
          taskType: task.task_type || 'Summary',
          assignedToId: task.assigned_to_id,
          assignedUser: task.assignedUser,
          location: task?.location_label,
        }}
        handleAssignUserChange={handleAssignUserChange}
        assignmentEditable={true}
      />
      <Flex direction={'column'} gap={6} mt={6}>
        <DescriptionBlock description={task?.task_desc || ''} />
        <DataPointsBlock
          summary={task?.error_analysis_summary}
          data={task?.data_points}
        />
        {task?.impact_amount && (
          <EstimatedSavingBlock
            impact={task?.impact_amount}
            impactFrequency={task?.impact_frequency}
          />
        )}
        <FeedbackBlock
          value={task?.feedback_sentiment}
          onThumbsDownClick={handleFeedbackSubmit(FEEDBACK_STATE.NEGATIVE)}
          onThumbsUpClick={handleFeedbackSubmit(FEEDBACK_STATE.POSITIVE)}
        />
        <CommentBlock comment={task?.comment} />
      </Flex>
    </>
  );
}

export default ErrorTaskContent;
